<template>
  <div>
    <div class="tw-w-full">
      <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Documents Upload</h3>
      <hr class="tw-mt-3 tw-mb-5">
    </div>
    <v-text-field class="tw-hidden" v-model="documents" :rules="rules"></v-text-field>

    <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-mt-4 md:tw-mt-10">
      <div class="tw-px-2 md:tw-px-16 tw-mt-4 md:tw-mt-0">
        <p>National ID Card</p>
        <file-uploads v-model="idImage" :added-image="addedIdImage" :name="`${registrationNumber}_idFrontImage`" :rules="[isObjectField()]" />
      </div>

      <div class="tw-px-2 md:tw-px-16 tw-mt-4 md:tw-mt-0">
        <p>Logbook</p>
        <file-uploads v-model="logbookImage" :added-image="addedLogbookImage" :name="`${registrationNumber}_LogbookImage`" :rules="[isObjectField()]" />
      </div>
      <div class="tw-px-2 md:tw-px-16 tw-mt-4 md:tw-mt-0">
        <p>Driving Licence (optional)</p>
        <file-uploads v-model="driverImage" :added-image="addedDriverImage" :name="`${registrationNumber}_LicenceFrontImage`" />
      </div>
    </div>
  </div>
</template>

<script>
import FileUploads from '@/components/shared/FileUploads';
import validations from '@/utils/validations';

export default {
  name: 'DocumentsUpload',
  components: { FileUploads },
  props: {
    rules: {
      type: Array,
      required: false,
    },
    registrationNumber: {
      type: String,
      required: true,
    },
    allDocuments: Array,
  },
  data() {
    return {
      driverImage: '',
      addedDriverImage: {},
      idImage: '',
      addedIdImage: {},
      logbookImage: '',
      addedLogbookImage: {},
      ...validations,
    };
  },
  computed: {
    documents() {
      let array = [];
      if (this.driverImage !== '') {
        array = array.concat(this.driverImage);
      }
      if (this.idImage !== '') {
        array = array.concat(this.idImage);
      }
      if (this.logbookImage !== '') {
        array = array.concat(this.logbookImage);
      }
      return array;
    },
  },
  watch: {
    documents(val) {
      this.$emit('input', val);
    },
  },
  created() {
    if (this.allDocuments.length > 0) {
      this.addedDriverImage = this.allDocuments.find((e) => e.documentName === `${this.registrationNumber}_LicenceFrontImage`);
      this.addedIdImage = this.allDocuments.find((e) => e.documentName === `${this.registrationNumber}_idFrontImage`);
      this.addedLogbookImage = this.allDocuments.find((e) => e.documentName === `${this.registrationNumber}_LogbookImage`);
    }
  },
};
</script>
